<style type="text/css" scoped>
	.calendar-layer-toggles .layer-mine {
		margin-right: 15px;
	}

	.calendar-layer-toggles .layer-filters label {
		margin-left: 15px;
	}

	.week-slider {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		text-transform: uppercase;
	}

	.week-slider h2 {
		margin-bottom: 0;
	}

	.week-slider .days {
		display: flex;
		flex-direction: row;
		border-top: 1px solid #e0e0e0;
		border-bottom: 1px solid #e0e0d0;
		padding-top: 3px;
		padding-bottom: 3px;
		flex-grow: 1;
	}

	.week-slider .day {
		flex-grow: 1;
		text-align: center;
		border-top: 1px solid transparent;
		border-bottom: 1px solid transparent;
		cursor: pointer;
	}

	.week-slider .day h3 {
		font-size: 14pt;
		font-weight: bold;
	}

	.week-slider .day.active h3,
	.week-slider .day:hover h3 {
		color: var(--brand-primary-color);
		border-top: 1px solid var(--brand-primary-color);
		border-bottom: 1px solid var(--brand-primary-color);
	}

	.week-slider h3 {
		margin: 0;
	}

	.calendar-day {
		padding-top: 5px;
	}

	.calendard-day .list-group-item {
		padding: 5px;
	}

	.event-time-off,
	.event-equipment-service,
	.event-generic {
		border-left-width: 1px;
		border-style: solid;
	}

	.event-starts-this-day {
		border-left-width: 12px;
		border-style: solid;
	}

	.event-time-off {
		border-color: green;
    	background-color: rgba(0,128,0,0.1);
	}

	.event-equipment-service {
		border-color: #fdbf77;
		background-color: rgba(253,191,119,0.1);
	}

	.event-generic {
		border-color: blue;
		background-color: rgba(0,0,128,0.1);
	}
</style>

<template>
<widget title="Your Week Ahead" :widget-spinner="widgetSpinner" :max-height="maxHeight">

	<template slot="header">
		<div class="d-flex align-items-center">
			<i class="fa fa-external-link-alt icon-button ml-2" v-on:click="$router.push('/schedule')"></i>
		</div>
	</template>

	<div class="week-slider">
		<h2 class="month">{{ moment().format("MMM") }} <small>{{ moment().format("YYYY") }}</small></h2>
		<div class="days">
			<div v-for="(day,index) in daysOfWeek" class="day" :class="{'active': day.active}" v-on:click="selectDay(index)">
				<h3><small>{{ day.dow }}</small><br>{{ day.monthDay }}</h3>
			</div>
		</div>
	</div>

	<div class="calendar-day">
		<div v-if="events.length > 0" class="list-group">
			<router-link v-for="(event,eventIndex) in events.slice(0,4)" :to="event.link" :key="'link_' + eventIndex" class="list-group-item list-group-item-action"
				:class="{
					'event-time-off': event.type == 'timeOff',
					'event-equipment-service': event.type == 'equipmentService',
					'event-generic': event.type == 'events',
					'event-starts-this-day': moment(event.start).format('YYYY-MM-DD') == moment().add(selectedDayIndex,'days').format('YYYY-MM-DD')
				}">
				<div class="d-flex flex-row align-items-center">
					<i class="fa fa-fw mr-3" :class="{
						'fa-wrench' : event.type == 'equipmentService',
						'fa-plus-square' : event.is_sickday == 1,
						'fa-umbrella-beach' : event.is_vacation == 1,
						'fa-calendar' : event.type == 'events'
					}"></i>
					<div>
						<h5 class="mb-0">
							<template v-if="'User' in event && event.User">
								<template v-if="'Job' in event && event.Job">
									<small>Assigned to Project #{{ event.Job.job_num }}</small>
								</template>
								<template v-else-if="'Service' in event && event.Service">
									<small>Assigned to Service #{{ event.Service.job_num }}</small>
								</template>
								<template v-else>
									<template v-if="event.is_vacation == 1">Vacation</template>
									<template v-else-if="event.is_sickday == 1">Medical Leave</template>

									<template v-else>Generic Event</template>
									<small> ({{event.User.first_name}} {{event.User.last_name}})</small>
								</template>

							</template>
							<template v-else-if="'Job' in event && event.Job">Project #{{event.Job.job_num}}</template>
							<template v-else-if="'Service' in event && event.Service">Service #{{event.Service.job_num}}</template>
							<small v-else>(Company Event)</small>
							@ {{ formatDateTimeToLocal(event.start_time,"time") }}
						</h5>
						<p class="mb-0" v-if="event.notes">{{ event.notes.length > 20 ? event.notes.substring(0,20)+'...' : event.notes }}</p>
					</div>
				</div>
			</router-link>
			<router-link v-if="events.length > 4" to="/schedule" class="list-group-item list-group-item-action">
				View More Events...
			</router-link>
		</div>
		<p v-else>You have no events for this day</p>
	</div>

</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Field from "@/components/Field"

import EventsMixins from "@/mixins/EventsMixins.js"

export default {
	name: "CalendarWidget",
	components: {
		Widget,
		Field
	},
	mixins: [EventsMixins],
	props: ["maxHeight"],
	data() {
		return {
			events: [],
			equipmentServices: [],
			widgetSpinner: false,
			selectedDayIndex: 0,
			layer: 'events'
		}
	},
	computed: {
		selectedDate() {
			let selectedDay = this.moment().add(this.selectedDayIndex,"days")

			return selectedDay.utc().format("YYYY-MM-DD")
		},
		daysOfWeek() {
			let vm = this
			let day = this.moment()

			let days = []

			for (var i = 0; i < 7; i++) {

				let dayObj = {
					dow: day.format("ddd"),
					monthDay: day.format("D"),
					active: false
				}

				if (i == vm.selectedDayIndex)
					dayObj.active = true

				days.push(dayObj)

				day.add(1,"days")
			}

			return days
		},
		/*
		compiledEvents() {
			let vm = this

			let compiled = []

			if (this.$store.calendarLayers.indexOf('events') >= 0 || this.$store.calendarLayers.indexOf("timeOff") >= 0) {

				let events = []

				if (this.$store.calendarLayers.indexOf('events') >= 0 && this.$store.calendarLayers.indexOf('timeOff') == -1) {
					//only events
					events = this.events.filter(event => (!vm.mineOnly || event.user_id == vm.$store.userDetails.id || event.user_id == 0) && event.is_sickday == 0 && event.is_vacation == 0)
				}
				else if (this.$store.calendarLayers.indexOf('events') == -1 && this.$store.calendarLayers.indexOf('timeOff') >= 0) {
					//only time off
					events = this.events.filter(event => (!vm.mineOnly || event.user_id == vm.$store.userDetails.id) && (event.is_sickday == 1 || event.is_vacation == 1))
				}
				else 
					events = this.events.filter(event => !vm.mineOnly || event.user_id == vm.$store.userDetails.id || event.user_id == 0)

				let formattedEvents = []

				events.forEach(event => {

					let eventTime = vm.moment(event.start)

					let color = "blue"
					let icon = "fa-calendar"
					let typeLabel = ""

					if (event.is_sickday == 1) {
						color = "#a56218"
						icon = "fa-h-square"
						typeLabel = "Sickday"
					}

					if (event.is_vacation == 1) {
						color = "green"
						icon = "fa-plane"
						typeLabel = "Vacation"
					}

					let title = event.title

					let eventObj = {
						date: eventTime.format("YYYY-MM-DD"),
						time: eventTime.format("hh:mm A"),
						title: event.title,
						description: event.description,
						icon: icon,
						typeLabel: typeLabel,
						id: event.id
					}

					if (event.user_id > 0 && "User" in event)
						eventObj.person = event.User.first_name+" "+event.User.last_name

					if (parseFloat(event.duration_hrs) > 0)
						eventObj.duration = parseFloat(event.duration_hrs)

					if (event.end) {
						let splitEvent = vm.splitMultiDayEvent(
							eventObj.date,
							eventObj.time,
							event.end,
							eventObj
						)

						formattedEvents = formattedEvents.concat(splitEvent)
					}
					else
						formattedEvents.push(eventObj)
				})

				if (vm.$store.calendarLayers.indexOf("equipmentService") >= 0) {
					formattedEvents = formattedEvents.concat(this.equipmentServices.map(eq => {
						return {
							date: eq.next_service_date,
							title: eq.description,
							description: eq.next_service_description,
							icon: "fa-wrench",
							typeLabel: "Maintenance Due",
							link: "/equipment/edit/"+eq.slug+"/log"
						}
					}))
				}

				compiled = compiled.concat(formattedEvents)
			}

			//sort by start date so they stack nicely and in order
			compiled.sort((a,b) => {
				if (vm.moment(a.date).isAfter(b.date))
					return -1
				else
					return 1
			})

			return compiled
		}
		*/
	},
	methods: {
		selectDay(index) {
			this.selectedDayIndex = index
			this.fetchScheduleEvents()
		},
		/*
		fetchEquipmentServices(month,year) {
			let vm = this

			let monthStart = this.moment([year,month - 1]).format("YYYY-MM-01")
			let monthEnd = this.moment([year,month - 1]).endOf("month").format("YYYY-MM-DD")

			let params = {
				filters: [
					["next_service_date >=",monthStart],
					["next_service_date <=",monthEnd]
				],
				fields: ["id","slug","next_service_date","next_service_mileage_or_time","description","next_service_description"]
			}

			this.getJSON("Equipment/get",params).then(response => {
				if (response.success) {
					vm.equipmentServices = response.data
				}
			})
		},
		*/
		fetchScheduleEvents() {
			let vm = this

			let promises = []

			let params = {
				start_time: this.moment(this.selectedDate+" 00:00:00").utc().format("YYYY-MM-DD HH:mm"),
				end_time: this.moment(this.selectedDate+" 23:59:59").utc().format("YYYY-MM-DD HH:mm:ss"),
				include: [
					{model:"User",fields:["id","first_name","last_name"]},
					{model: "Job", fields: ["id","slug","job_num","job_name"]},
					{model: "Service", fields: ["id","slug","job_num","job_name"]}
				],
				filters: [
					["user_id",this.$store.userDetails.id]
				]
			}

			promises.push(this.getJSON("ScheduleEvent/get-range",params))

			let eqParams = {
				filters: [
					["next_service_date",this.selectedDate]
				],
				fields: ["id","slug","next_service_date","next_service_mileage_or_time","description","next_service_description"]
			}

			promises.push(this.getJSON("Equipment/get",eqParams))

			Promise.all(promises).then(responses => {

				if (responses[0].success && responses[1].success) {
					let combinedEvents = responses[0].data.map(event => {
						if (event.is_vacation == 1 || event.is_sickday == 1) {
							event.type = "timeOff"

							if (event.is_vacation == 1)
								event.title = "Vacation"
							else if (event.is_sickday == 1)
								event.title = "Medical Leave"
						}
						else {
							event.type = "events"
						}

						let startDate = vm.moment(event.start_time).format("YYYY-MM-DD")

						event.link = "/schedule/daily/"+startDate

						return event
					})

					combinedEvents = combinedEvents.concat(responses[1].data.map(eqService => {
						eqService.type = "equipmentService"
						eqService.title = eqService.next_service_description
						eqService.link = "/equipment/edit/"+eqService.slug+"/log"

						return eqService
					}))

					vm.events = combinedEvents
				}

			})
		},
		/*
		fetchEvents() {
			let vm = this

			let eqParams = {
				filters: [
					["next_service_date",this.selectedDate]
				],
				fields: ["id","slug","next_service_date","next_service_mileage_or_time","description","next_service_description"]
			}

			let promises = []

			let filtersCondition1 = [
				["start_time >=",this.selectedDate+" 00:00:00"],
				["start_time <=",this.selectedDate+" 23:59:59"],
				["rejected_by",0],
				["end",null]
			]

			let filtersCondition2 = [
				["start_time <=",this.selectedDate+ " 00:00:00"],
				["end_time >=",this.selectedDate],
				["rejected_by",0]
			]

			if (!this.hasModulePermRead('Users')) {
				filtersCondition1.push(["user_id",[0,this.$store.userDetails.id]])
				filtersCondition2.push(["user_id",[0,this.$store.userDetails.id]])
			}

			let eventParams = {
				filters: filtersCondition1,
				include: [{model:"User",fields:["id","first_name","last_name"]}]
			}

			promises.push(this.getJSON("Event/get",eventParams))

			eventParams.filters = filtersCondition2

			promises.push(this.getJSON("Event/get",eventParams))

			promises.push(this.getJSON("Equipment/get",eqParams))

			Promise.all(promises).then(responses => {

				if (responses[0].success && responses[1].success && responses[2].success) {
					let combinedEventModelEvents = responses[0].data.concat(responses[1].data)

					let combinedEvents = combinedEventModelEvents.map(event => {
						if (event.is_vacation == 1 || event.is_sickday == 1)
							event.type = "timeOff"
						else
							event.type = "events"

						event.link = "/calendar"

						return event
					})

					combinedEvents = combinedEvents.concat(responses[2].data.map(eqService => {
						eqService.type = "equipmentService"
						eqService.title = eqService.next_service_description
						eqService.link = "/equipment/edit/"+eqService.slug+"/log"

						return eqService
					}))

					vm.events = combinedEvents
				}
			})

		},
		*/
	},
	created() {
		this.fetchScheduleEvents()
		this.fetchUsers()
	}
}
</script>